import { Box, Grid, Typography } from '@mui/material';
import * as yup from 'yup';
import FormikFormWrapper from 'libs/formik_fields/FormikFormWrapper';
import { LoadingButton } from '@mui/lab';
import SingleFileUploadField from 'libs/formik_fields/SingleFileUploadField';

const emptyData = {
    image: { url: '', key: '', new: false, loading: false }
};

const documentSchema = yup.object().shape({
    image: yup.mixed().required('Please add image.')
});

const FolderAddDocFormContent = ({ disabledFields = [], ...formik }) => {
    const { isSubmitting } = formik;

    return (
        <Grid container spacing={0} py={2}>
            <Grid item xs={12} md={6} px={1}>
                <Box sx={{ display: 'flex', alignItems: 'baseline', px: '8px' }}>
                    <Typography variant="h4">Add image</Typography>
                </Box>
                <SingleFileUploadField name="image" label="" accept="image/*" fileType="image" />
            </Grid>
            <Grid item xs={12} md={6} px={1}>
                <Box sx={{ display: 'flex', alignItems: 'baseline', px: '8px' }}>
                    <Typography variant="h4">Add document</Typography>
                </Box>
                <SingleFileUploadField
                    name="document"
                    label=""
                    accept=".pdf, .xls, .xlsx, application/pdf, application/vnd.ms-excel"
                    fileType="application"
                    fileIcon
                    noValidation
                />
            </Grid>
            <Grid item xs={12} px={1}>
                <LoadingButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    disableElevation
                    loading={isSubmitting}
                    loadingPosition="center"
                >
                    Save
                </LoadingButton>
            </Grid>
        </Grid>
    );
};

function CommonPageAddDocument({ handleSubmit, initialValues, disabledFields }) {
    return (
        <FormikFormWrapper
            initialValues={initialValues ?? emptyData}
            onSubmit={handleSubmit}
            validationSchema={documentSchema}
            FormContent={FolderAddDocFormContent}
            disabledFields={disabledFields}
        />
    );
}

export default CommonPageAddDocument;
